import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AiInterviewDetailsResponse, DeleteInterviewResponse } from '@edtech-ui/core/models/ai-interview/ai-interview-details';
import { AiInterviewRoleResponse, CreateRolePayload, CreateRoleResponse } from '@edtech-ui/core/models/ai-interview/getroles';
import { AiInterviewCompaniesResponse, CreateCompanyPayload, CreateCompanyResponse } from '@edtech-ui/core/models/ai-interview/interview-companys';
import { AiInterviewRoundsResponse } from '@edtech-ui/core/models/ai-interview/interview-round';
import { InterviewHistoryResponse } from '@edtech-ui/core/models/ai-interview/interviewhistory';
import { MockInterviewPracticeHistoryResponse } from '@edtech-ui/core/models/ai-interview/mock-interview-history';
import { environment } from 'environments/environment';
import { BehaviorSubject, catchError, Observable, throwError } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class AiInterviewServiceService {

	private availableTimeSubject = new BehaviorSubject<number | null>(null);
	availableTime$ = this.availableTimeSubject.asObservable();

	apiUrl = environment.aiInterviewManagementUrl;
	mockTestUrl = environment.mockInterview;

	constructor(private readonly http: HttpClient) { }
	createRole(payload: CreateRolePayload): Observable<CreateRoleResponse> {
		return this.http.post<CreateRoleResponse>(`${this.apiUrl}/createRole`, payload);
	}

	getRoles(): Observable<AiInterviewRoleResponse> {
		return this.http.get<AiInterviewRoleResponse>(`${this.apiUrl}/getRoles`);
	}

	getInterviewRounds(): Observable<AiInterviewRoundsResponse> {
		return this.http.get<AiInterviewRoundsResponse>(`${this.apiUrl}/getInterviewRounds`);
	}

	createCompany(payload: CreateCompanyPayload): Observable<CreateCompanyResponse> {
		return this.http.post<CreateCompanyResponse>(
			`${this.apiUrl}/createCompany`,
			payload
		);
	}

	getCompaniesList(): Observable<AiInterviewCompaniesResponse> {
		return this.http.get<AiInterviewCompaniesResponse>(`${this.apiUrl}/getCompaniesList`
		);
	}
	getInterviewHistory(
		page: number,
		pageSize: number,
		search?: string,
		round?: string
	): Observable<InterviewHistoryResponse> {
		let params = new HttpParams()
			.set('page', page.toString())
			.set('page_size', pageSize.toString());

		if (search?.trim()) {
			params = params.set('search', search.trim());
		}
		if (round && round !== 'All') {
			params = params.set('round', round);
		}

		return this.http.get<InterviewHistoryResponse>(`${this.apiUrl}/interview-history`, { params }).pipe(
			catchError((error) => {
				return throwError(() => error);
			})
		);
	}

	getInterviewDetails(sessionId: string): Observable<AiInterviewDetailsResponse> {
		return this.http.get<AiInterviewDetailsResponse>(`${this.apiUrl}/interview-details/${sessionId}`);
	}

	deleteInterview(sessionId: string): Observable<DeleteInterviewResponse> {
		const url = `${this.apiUrl}/interview/${sessionId}`;
		return this.http.delete<DeleteInterviewResponse>(url);
	}

	setAvailableTime(time: number) {
		this.availableTimeSubject.next(time);
	}

	getAvailableTime(): number | null {
		return this.availableTimeSubject.value;
	}


	getMockInterviewPracticeHistory(page: number, pageSize: number, search?: string): Observable<MockInterviewPracticeHistoryResponse> {
		let params = new HttpParams().set('page', page.toString()).set('page_size', pageSize.toString());
		if (search && search.trim()) {
			params = params.set('search', search.trim());
		}
		return this.http.get<MockInterviewPracticeHistoryResponse>(`${this.mockTestUrl}`, { params });
	}



}
